import { useSearchParams } from "react-router-dom"
import { observer, useLocalObservable } from "mobx-react"
import { Button, Flex } from "antd"
import { useForm } from "antd/es/form/Form"
import { choose } from "choose-matching"

import { balancesStore } from "@src/app/balanceStore"
import { GlobalCurrenciesCollection } from "@src/app/CurrenciesCollection"
import { MassPayoutsCollection } from "@src/pages/massPayouts/crypto/classess/MassPayoutsCryptoCollection"
import { ManualPayoutsForm } from "@src/pages/massPayouts/crypto/ui/manual/ManualPayoutsForm"
import { MassPayoutsForm } from "@src/pages/massPayouts/crypto/ui/mass/MassPayoutsForm"
import { MassPayoutsTable } from "@src/pages/massPayouts/crypto/ui/MassPayoutsTable"

export const enum MassPayoutsPageView {
  MANUAL = "manual",
  UPLOAD = "upload",
}

type Props = {
  view: MassPayoutsPageView
}

export const MassPayoutsCryptoPage = observer(({ view }: Props) => {
  const massPayoutsCollection = useLocalObservable(
    () => new MassPayoutsCollection(),
  )

  const currenciesCollection = GlobalCurrenciesCollection()
  const balance = balancesStore

  const [form] = useForm()

  return (
    <Flex gap={32} vertical>
      {choose(
        [
          view === MassPayoutsPageView.MANUAL,
          <ManualPayoutsForm
            balances={balance.balances}
            collection={massPayoutsCollection}
            currencies={{
              isLoading: currenciesCollection.isLoading,
              options: currenciesCollection.selectOptionsCrypto,
            }}
            form={form}
          />,
        ],
        [
          view === MassPayoutsPageView.UPLOAD,
          <MassPayoutsForm collection={massPayoutsCollection} />,
        ],
      )}
      <MassPayoutsTable collection={massPayoutsCollection} />
    </Flex>
  )
})
